import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

export interface IIconClose extends IIcon {
  width?: string;
}

const svg = (width: string = '20') => (
  <svg width={width} height={width} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icona=Close">
      <path
        id="Close"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9625 13.47L20.9325 7.5L22.425 8.9925L16.455 14.9625L22.5 21.0075L21.0075 22.5L14.9625 16.455L8.9925 22.425L7.5 20.9325L13.47 14.9625L7.575 9.0675L9.0675 7.575L14.9625 13.47Z"
        fill="#fff"
      />
    </g>
  </svg>
);

const IconClose: React.FC<IIconClose> = (props: ReactProps) => {
  const { width, ...prop } = props;
  return <Icon {...prop} svg={() => svg(width)} />;
};

export default IconClose;
